/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useEffect, useState, useCallback, useContext, useRef } from "react";
import CardHeader from "../../../components/CardHeader";
import Toast from "../../../components/Toast";
import { formatAdjustedDate } from "../../../CommonMethods/formatDate";
import LedgerTable from './Components/LedgerTable'
import NavBar from "./Components/NavBar";
import SubLedgerTable from "./Components/SubLedgerTable";
import OpeningStockTable from "../Components/OpeningStockTable";
import { useNavigate, useSearchParams } from "react-router-dom";
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import { dataService } from "../../../services/data.services";
import CustomOverLay from "../../../components/CustomOverlay";
import Filter from "../Components/TopbarComponents/Filter";
import GlobalContext from "../../../components/Context/GloablContext";
import { useOnClickOutside } from "../../../CommonMethods/OutsideClick";
import ItemShimmer from "../../../components/Shimmer/itemShimmer";
import ClsoingStockTable from "../Components/ClsoingStockTable";
import ShimmerLedgerTable from "../Components/LedgerTableShimmer";
import TransactionTable from "./Components/TransactionTable";
import Loader from "../../../components/Loader";
import moment from 'moment';

const ProfitAndLoss = ({type}) => {
    const [searchParams, setSearchParams] = useSearchParams('')
    const {setToastmessage, reloadFY, setReloadFY} = useContext(GlobalContext);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const navigate = useNavigate('')
    const [finacialYear, setFinacialYear] = useState('')
    const [academicYears, setAcademicYears] = useState('')
    const [loading, setLoading] =useState(true) 
    const [exportBtnLoading, setExportBtnLoading] = useState(false)
    const [subLedgerWithGroupsLoading, setSubLedgerWithGroupseLoading] = useState(false)
    const [transactionTableLoading, setTransactionTableLoading] = useState(false)
    const [subLedgerLoading, setSubLedgerLoading] = useState(false)
    const [ledgerTableloading, setLedgerTableLoading] = useState(false)
    const [openingStockLoading, setOpeningStockTableLoading] = useState(false)
    const [closingStockTableLoading, setClsoingStockTableLoading] = useState(false)
    const [selectedDateRange, setSelectedDateRange] = useState(searchParams.get('dropname') !== null ? searchParams.get('dropname') : 'Financial Year')
    const [selectedName, setSelectedName] = useState(searchParams?.get('main') !== null ? searchParams?.get('main'):'')  ;
    const [currentFinacialYear, setCurrentFinacialYear] = useState('')
    const [FilterData, setFilterData] = useState({date_range : [],});
    const [filterCount, setFilterCount] = useState(0)
    const [FilterCheckbox, setFilterCheckBox] = useState({})
    const [selectedFilter, setSelectedFilter] = useState(Object.keys(FilterData !==undefined&& FilterData)[0]||'city');
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [pageType, setPageType] = useState(type)
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const [profitAndLossStartDate, setProfitAndLossStartDate] = useState(null)
    const [profitAndLossEndDate, setProfitAndLossEndDate] = useState(null)
    const [profitAndLoss, setProfitAndLoss] = useState({})
    const [netProfit, setNetProfit] = useState(0)
    const [subLedgerData, setSubLedgerData] = useState({})
    const [subLedgerDataWithGroups, setSubLedgerDataWithGroups] = useState([])
    const [transactionList, setTransactionList] = useState({})
    const [transactionCount, setTransactionCount] = useState({})
    const [openingStockCount, setOpeningStockCount] = useState(0)
    const [openingStockList, setOpeningStockList] = useState([])
    const [closingStockList, setClosingStockList] = useState([])
    const [closingStockCount, setClosingStockCount] = useState(0)
    const outSideClick = useRef();
    const validTypes = ['main', 'opening-stock', 'drill_down', 'group','mainGroup', 'closing-stock', "transaction"]; // Add other valid types if any
    const allowedParams = [
        'main', 'type', 'dropname', 'filter', 'page_number', 'start_date', 'end_date', 'student_id','student_uuid',
        'ledger_id', 'ay_id', 'class_id', 'section_id', 'inv_id', 'page_number_sub_inventory', 'grand_total'
    ]; // Add other valid types if any
    const requiredGroupParams = ['main', 'dropname', 'filter', 'start_date', 'end_date'];//Don't change these are set and predefined for the filter
    const allowedDropnames = ['Financial Year', 'Academic Year', 'Custom'];//Don't change these are set and predefined for the filter
    const [FYLoading, setFYLoading] = useState(true);

    /**
     * The function `validateParams` checks if the provided search parameters meet certain criteria related
     * to required group parameters, allowed parameters, and predefined values for 'dropname'.
     * @returns The `validateParams` function returns a boolean value - `true` if all validation checks
     * pass, and `false` if any of the validation checks fail.
     */
    const validateParams = (searchParams) => {
        //if filter is applies all the filter params realted to filter should be present
        const presentRequiredParams = requiredGroupParams.filter(param => searchParams.has(param) && searchParams.get(param).trim() !== '');
        if (presentRequiredParams.length > 0 && presentRequiredParams.length !== requiredGroupParams.length) {
            return false;
        }
        //Only the params we are using in this feature should be present
        for (let key of searchParams.keys()) {
            if (!allowedParams.includes(key)) {
                return false;
            }
        }
        //dropname has a predefined values it should be among them only
        if (searchParams.has('dropname') && !allowedDropnames.includes(searchParams.get('dropname'))) {
            return false;
        }
        //the page type should be valid
        const type = searchParams?.get('type') === null ? 'main' : searchParams.get('type');
        if (!validTypes.includes(type)) {
            return false;
        }
        return true;
    };
      
    /**
     * The function `ValidateParamsAndRedirect` checks if the URL search parameters are valid and redirects
     * to a 404 page if they are not.
     */
    const ValidateParamsAndRedirect = () => {
        const searchParams = new URLSearchParams(location.search);
        const isValid = validateParams(searchParams);
        if (!isValid) {
            navigate('/404');
        }
    };

    /**
     * The `formatDate` function takes an input date string and returns it in the format "YYYY-MM-DD".
     * @returns The function `formatDate` returns a formatted date string in the format "YYYY-MM-DD".
     */
    const formatDate = (inputDateString) => {
        const inputDate = new Date(inputDateString);
        const year = inputDate.getFullYear();
        const month = String(inputDate.getMonth() + 1).padStart(2, '0');
        const day = String(inputDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    /*Convert Apr 1, 2023 to Apr 01, 2023 */
    const formatMMDDate = (dateStr) => {
        if(dateStr === undefined || dateStr === '' || dateStr == null){
            return dateStr;
        }
        const [month, day, year] = dateStr.split(' ');
        const formattedDay = day.replace(',', '').padStart(2, '0'); // Ensure day is two digits
        return `${month} ${formattedDay}, ${year}`;
    };

    const exportBtnhandler = () => {
        if(exportBtnLoading || loading || openingStockLoading || closingStockTableLoading || transactionTableLoading || ledgerTableloading || subLedgerLoading || subLedgerWithGroupsLoading)
        {
            return;
        }
        let mainGroup;
        let isExport = true
        const pathSegments = window.location.pathname.split('/');
        if (pathSegments.includes('income')) {
            mainGroup = 'Income';
        } else if (pathSegments.includes('expenses')) {
            mainGroup = 'Expenses';
        }        
        setPageType(searchParams?.get('type') === null ? 'main' : searchParams?.get('type'))
        if(pageType === 'main' || location.pathname === '/financial-statements/profit-and-loss-sheet'){
            getProfitAndLossViewCall(isExport);
        } else {
            setExportBtnLoading(false);
        }
        if(searchParams?.get('type') === 'opening-stock') getOpeningStockListAPICall(isExport)
        if(searchParams?.get('type') === 'closing-stock') getClosingStockListAPICall(isExport)
        if(searchParams?.get('type') === "group" || searchParams?.get('type') === 'mainGroup') getSubLedgerWithGroupsAPICall(mainGroup, isExport)
        if(searchParams?.get('type') === "drill_down") getSubLedgerAPICall(mainGroup, isExport)
        if(searchParams?.get('type') === 'transaction') getTransactionTableAPICall(mainGroup, isExport)
    }
    
    //Fliter Functions----
    /**
     * The function `updateFilterCheckBox` creates an object with non-null properties from searchParams,
     * filters out null or undefined values, updates the state with the filtered values, and counts the
     * number of filtered values.
     */
    const updateFilterCheckBox = () => {
        // Create an object with non-null properties from searchParams
        const filterState = {
            start_date: searchParams.get('start_date'),
            end_date: searchParams.get('end_date'),
        };
        // Filter out null or undefined values
        const filteredFilterState = Object.fromEntries(
            Object.entries(filterState).filter(([_, value]) => value !== null && value !== undefined)
        );
        // Update the state with the filtered values
        setFilterCheckBox(filteredFilterState);
        let count = 0
        Object.keys(filteredFilterState).map((item) =>  {
            if(filteredFilterState[item] &&filteredFilterState[item]?.length !== 0 && item!="end_date") {
                count += 1
            }
        })
        setFilterCount(count)
    };
    
    /**
     * The function `getCount` counts the number of non-empty values in the `FilterCheckbox` object and
     * updates the `filterCount` state variable accordingly.
     */
    const getCount = (type) => {
        let count = 0
        Object.keys(FilterCheckbox).map((item) =>  {
            if(FilterCheckbox[item] &&FilterCheckbox[item]?.length !== 0 && item!="end_date") {
                count += 1
            }
        })
        if(type && searchParams.get('filter') !== false) {
            setFilterCount(count)
        } else {
            setFilterCount(0)
        }
    }

    /**
     * The function `handleOpenFilter` updates the filter values based on the search parameters and toggles
     * the filter open state.
     */
    const handleOpenFilter = () => {
        let filter_val = {}
        Object.keys(FilterData).map((item) => {
            let params = Object.fromEntries(searchParams);
            Object.keys(params).map((subitem) => {
                if(item === subitem) {
                    filter_val[item] = params[item].split(',')
                }
                if(subitem==='start_date' ||subitem==='end_date'){
                    filter_val[subitem]=params[subitem]
                }
            })
            setFilterCheckBox(filter_val)      
        })
        setIsFilterOpen((prevState)=> !prevState)
        setSelectedName(searchParams?.get('main') !== null ? searchParams?.get('main') : currentFinacialYear)
        setSelectedFilter('date_range')
        setSelectedDateRange(searchParams.get('dropname') !== null ? searchParams.get('dropname') : 'Financial Year')
    }

    /* The `useOnClickOutside` is a custom hook that is used to detect clicks outside of a specific
    element. In this case, it is used to detect clicks outside of the filter component. When a click is
    detected outside of the filter component, the callback function `() => { setIsFilterOpen(false) }`
    is executed, which sets the `isFilterOpen` state to `false`, closing the filter component. */
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    /**
     * The function `handleSelectObject` updates the state of `FilterCheckbox` based on the selected
     * object's id, dateString, and selectedFilter.
     */
    const handleSelectObject = (id,dateString,selectedFilter) => {
        if(id === 'start_date' || id === 'end_date') {
            setFilterCheckBox((prv)=>({
                ...prv,
                [id]: dateString
            }))
        }  else {
            setFilterCheckBox((prv)=>({
                ...prv,
                [selectedFilter]:[id]
            }))
        } 
    }
    /**
     * The function `handleApplyFilter` is used to apply filters to a search query and update the search
     * parameters accordingly.
     */
    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        if(type && Object.keys(FilterCheckbox).length !==0) {
            params.main = selectedName
            params.type = 'main'
            if (selectedName === 'Custom') {
                if((FilterCheckbox['start_date']!==null && FilterCheckbox['end_date']!==null)){
                    params.dropname = 'Custom';
                } else {
                    setSearchParams({...params})
                }
            } else if (selectedName.includes('FY')) {
                params.dropname = 'Financial Year';
            } else {
                params.dropname = 'Academic Year';
            }
            setSearchParams({ ...params})
            let flag = true;
            params["filter"] = true
            params.page_number = 1
            Object.keys(FilterCheckbox).map((item) => {
                let val = ""
                if((item === 'start_date' || item === 'end_date') && FilterCheckbox[item]!==null) {
                    let val = FilterCheckbox[item]
                    params[item] = searchParams.get(item) !== val ? formatDate(val) : val
                    setSearchParams({ ...params})
                    flag = false
                } else if(FilterCheckbox[item] && FilterCheckbox[item]?.length !== 0 ) {
                    FilterCheckbox[item].map((key) => {
                        val += `${key},`
                    })
                    params[item] = val.slice(0, -1)
                    setSearchParams({ ...params})
                    flag = false
                } else {
                    delete params[item] 
                    setSearchParams({ ...params})  
                }
                if(flag) {
                    delete params.filter
                    setSearchParams({ ...params})  
                }
            })
            delete params?.ledger_id
            delete params?.ay_id
            delete params?.class_id
            delete params?.section_id
            delete params?.student_id
            delete params?.student_uuid
            delete params?.grand_total
            delete params?.page_number
            delete params?.page_number_sub_inventory
            delete params?.inv_id
            navigate(`/financial-statements/profit-and-loss-sheet${
                Object.keys(params).length === 0 
                    ? '' 
                    : `?${new URLSearchParams(params).toString()}`}`)
            setPageType('main')
        } else {
            setSearchParams({})
            setSelectedDateRange('')
            setSelectedName('')
            setFilterCheckBox([])
            setSelectedFilter('date_range')
            navigate('/financial-statements/profit-and-loss-sheet')
            setPageType('main')
        }
        getCount(type)
    }
    //----
    /**
     * The function `formatAndSetPath` takes a type and a path, splits the path into an array, formats the
     * parts based on the type, and returns a formatted string with '>' as separators.
     * @returns The function `formatAndSetPath` returns a formatted string that represents the path
     * starting from the specified `type` in the input `path`. If the `type` is found in the path, it
     * formats the path by capitalizing the first letter of each word separated by '_' and joining them
     * with '>'. If the `type` is not found in the path, it logs an error message and
     */
    const formatAndSetPath = (type, path, lowercase) => {
        // Split the path into an array by '/'
        const pathArray = path.split('/');
        const startIndex = pathArray.indexOf(type);
        if (startIndex !== -1) {
            const relevantParts = pathArray.slice(startIndex);
            const formattedParts = relevantParts.map((part, index) => {
                // If it's the last part and lowercase is true, do not capitalize it
                if ( index !== 0 ) {
                    return part;
                } else {
                    return part.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
                }
            });
            const formattedString = formattedParts.join(' > ');
            return formattedString;
        } else {
            console.error(`Path does not contain "${type}"`);
            return '';
        }
    };

    //API Calls----
    /**
     * The function `getFinancialYears` retrieves financial years data from an API, sets the financial
     * years state, sets the current financial year state, and updates the search parameters.
     */
    const getFinancialYears = async() => {
        try {
            const branch_id = await GetBranchId()
            let endpoint = `financial-years?branch_id=${branch_id}&filter=true&status=open,closed,ongoing&sort=start_date%2Bdesc`;
            const response = await dataService.GetAPI(endpoint, true)
            const temp1 = response?.data?.data?.financial_years
            setFinacialYear(temp1)
            const selectedFY = JSON.parse(localStorage.getItem('FY_details'));
            setCurrentFinacialYear(selectedFY.name)
            setSelectedName(searchParams?.get('main') !== null ? searchParams?.get('main') : selectedFY.name)
            const ongoingFYData = temp1.find(item => item.name === selectedFY.name);
            // If there's ongoing data, set the start and end dates in the state
            if (ongoingFYData) {
                setStartDate(ongoingFYData.start_date);
                setEndDate(calculateEndDate(ongoingFYData.end_date));
            }
        }
        catch (error) {
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        }
        finally {
            setFYLoading(false)
        }
        // setSearchParams({})
    }

    /**
     * The function `getAcademicYears` retrieves ongoing and upcoming academic years from an API based on
     * the branch ID and sets the retrieved data to the state variable `AcademicYears`.
     */
    const getAcademicYears = async() => {
        const branch_id = await GetBranchId()
        let endpoint = `academic-years?branch_id=${branch_id}&filter=true&status=ongoing,upcoming,completed`;
        const response = await dataService.GetAPI(endpoint, true)
        const temp = response?.data?.data?.data
        setAcademicYears(temp)
    }

    /* The below code is a React function component that uses the `useCallback` hook to define a function
    called `getProfitAndLossViewCall`. This function is an asynchronous function that fetches data
    related to profit and loss from an API endpoint. */
    const getProfitAndLossViewCall = useCallback(async (isExport) => {
        try {   
            isExport ? setExportBtnLoading(true) : setLedgerTableLoading(true)     
            const branch_id = await GetBranchId()
            let endpoint = `profit-and-loss?branch_id=${branch_id}${`${
                searchParams?.get('start_date') === null ?`&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams?.get('start_date')}`}${
                isExport ?`&export=true` : ''}${
                searchParams?.get('end_date') === null ? `&end_date=${endDate.substring(0, 10)}` :`&end_date=${searchParams?.get('end_date')}`}`}`;
            const response = await dataService.GetAPI(endpoint)
            if(isExport) {
                setToastmessage(response?.data?.data?.message)
                window.open(response?.data?.data?.pre_signed_url)
            } else {
                const temp1 = response?.data?.data
                const temp2 = response?.data?.data?.start_date
                const temp3 = response?.data?.data?.end_date
                const temp4 = response?.data?.data?.net_profit
                setProfitAndLoss(temp1)
                setProfitAndLossStartDate(temp2)
                setProfitAndLossEndDate(temp3)
                setNetProfit(temp4)
                updateFilterCheckBox();
            }
        } catch(error) {  
            if (error?.response?.status === 403) {
                setToastErrorMessage('You are not authorized to perform this action')
                navigate('/access-denied');
                return;  
            }
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.log(error)
            setLoading(false)
            setExportBtnLoading(false)
            setLedgerTableLoading(false)
            !isExport &&navigate('/404')
        } finally{
            !isExport &&updateFilterCheckBox();
            setLoading(false)
            setExportBtnLoading(false)
            setLedgerTableLoading(false)
        }
    }, [searchParams, FYLoading]);

    /* The below code is a React function component that defines a `getOpeningStockListAPICall` function
    using the `useCallback` hook. This function is an asynchronous API call that retrieves data related
    to opening stock from a backend server. */
    const getOpeningStockListAPICall = useCallback(async (isExport) => {
        if(searchParams?.get('type') === 'opening-stock'){
            const ledgerPath = formatAndSetPath('expenses', location.pathname)
            try {   
                isExport ? setExportBtnLoading(true) : setOpeningStockTableLoading(true)     
                const branch_id = await GetBranchId()
                let endpoint = `profit-and-loss/opening-stock?branch_id=${branch_id}&ledger=${ledgerPath}${`${
                    searchParams?.get('page_number') === null ? `&page_number=1` : `&page_number=${searchParams?.get('page_number')}`}${
                    isExport ?`&export=true` : ''}${
                    searchParams?.get('start_date') === null ? `&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams?.get('start_date')}`}${
                    searchParams?.get('end_date') === null ? `&end_date=${endDate.substring(0, 10)}` :`&end_date=${searchParams?.get('end_date')}`}`}`;
                const response = await dataService.GetAPI(endpoint)
                if(isExport) {
                    setToastmessage(response?.data?.data?.message)
                    window.open(response?.data?.data?.pre_signed_url)
                } else {
                    const temp1 = response?.data?.data?.data
                    const temp2 = response?.data?.data?.total_count
                    const temp3 = response?.data?.data?.start_date
                    const temp4 = response?.data?.data?.end_date
                    if(response?.data?.data?.total_count === 0 || response?.data?.data?.data?.length === 0 ){
                        navigate('/financial-statements/profit-and-loss-sheet')
                        setToastErrorMessage("Something went wrong")
                    }
                    setOpeningStockList(temp1)
                    setOpeningStockCount(temp2)
                    setProfitAndLossStartDate(temp3)
                    setProfitAndLossEndDate(temp4)
                    updateFilterCheckBox();  
                }
            } catch(error) {  
                if (error?.response?.status === 403) {
                    setToastErrorMessage('You are not authorized to perform this action')
                    navigate('/access-denied');
                    return;  
                }
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
                console.log(error)
                setExportBtnLoading(false)
                setLoading(false)
                setOpeningStockTableLoading(false)
                !isExport &&navigate('/404')    
            } finally{
                !isExport &&updateFilterCheckBox();                
                setLoading(false)
                setExportBtnLoading(false)
                setOpeningStockTableLoading(false)
            }
        } else {
            navigate('/financial-statements/profit-and-loss-sheet')
        }
    }, [searchParams, FYLoading]);

    /* The below code is a JavaScript React function using the `useCallback` hook to define an asynchronous
    function `getClosingStockListAPICall`. This function makes an API call to fetch closing stock data
    for a specific branch and ledger. It sets loading states, retrieves branch ID, constructs the API
    endpoint with query parameters, makes the API call using `dataService.GetAPI`, processes the
    response data, updates state variables with the fetched data, handles error scenarios by displaying
    error messages and navigating to appropriate pages, and finally updates filter checkboxes and
    loading states. */
    const getClosingStockListAPICall = useCallback(async (isExport) => {
        const ledgerPath = formatAndSetPath('income', location.pathname)
        try {   
            isExport ? setExportBtnLoading(true) : setClsoingStockTableLoading(true)     
            const branch_id = await GetBranchId()
            let endpoint = `profit-and-loss/closing-stock?branch_id=${branch_id}&ledger=${ledgerPath}${`${
                searchParams?.get('page_number') === null ? `&page_number=1` : `&page_number=${searchParams?.get('page_number')}`}${
                isExport ?`&export=true` : ''}${
                searchParams?.get('start_date') === null ? `&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams?.get('start_date')}`}${
                searchParams?.get('end_date') === null ? `&end_date=${endDate.substring(0, 10)}` :`&end_date=${searchParams?.get('end_date')}`}`}`;
            const response = await dataService.GetAPI(endpoint)
            if(isExport) {
                setToastmessage(response?.data?.data?.message)
                window.open(response?.data?.data?.pre_signed_url)
            } else {
                const temp1 = response?.data?.data?.data
                const temp2 = response?.data?.data?.total_count
                const temp3 = response?.data?.data?.start_date
                const temp4 = response?.data?.data?.end_date
                if(response?.data?.data?.total_count === 0|| response?.data?.data?.data?.length === 0){
                    navigate('/financial-statements/profit-and-loss-sheet')
                    setToastErrorMessage("Something went wrong")
                }
                setClosingStockList(temp1)
                setClosingStockCount(temp2)
                setProfitAndLossStartDate(temp3)
                setProfitAndLossEndDate(temp4)
                updateFilterCheckBox();  
            }
        } catch(error) {  
            if (error?.response?.status === 403) {
                setToastErrorMessage('You are not authorized to perform this action')
                navigate('/access-denied');
                return;  
            }
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.log(error)
            setLoading(false)
            setExportBtnLoading(false)
            setClsoingStockTableLoading(false)
            !isExport &&navigate('/404')    
        } finally{
            !isExport &&updateFilterCheckBox();            
            setLoading(false)
            setExportBtnLoading(false)
            setClsoingStockTableLoading(false)
        }
        // } else {
        //     navigate('/financial-statements/profit-and-loss-sheet')
        // }
    }, [searchParams, FYLoading]);


    /* The below code is a JavaScript React function that makes an API call to retrieve subledger data with
    groups based on a main group parameter. Here is a breakdown of what the code is doing: */
    const getSubLedgerWithGroupsAPICall = useCallback(async (mainGroup, isExport) => {
        const ledgerPath = formatAndSetPath(mainGroup?.toLowerCase(), location.pathname, true)
        try {   
            isExport ? setExportBtnLoading(true) : setSubLedgerWithGroupseLoading(true)     
            const branch_id = await GetBranchId()
            let endpoint = `profit-and-loss/view-child?branch_id=${branch_id}&main_parent=${mainGroup}&ledger=${ledgerPath}${`${
                isExport ?`&export=true` : ''}${
                searchParams?.get('start_date') === null ? `&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams?.get('start_date')}`}${
                searchParams?.get('end_date') === null ? `&end_date=${endDate.substring(0, 10)}` :`&end_date=${searchParams?.get('end_date')}`}`}`;
            const response = await dataService.GetAPI(endpoint)
            if(isExport) {
                setToastmessage(response?.data?.data?.message)
                window.open(response?.data?.data?.pre_signed_url)
            } else {
                const temp1 = response?.data?.data?.data
                const temp3 = response?.data?.data?.start_date
                const temp4 = response?.data?.data?.end_date
                if(response?.data?.data?.data?.length === 0){
                    navigate('/financial-statements/profit-and-loss-sheet')
                    setToastErrorMessage("Something went wrong")
                }
                setSubLedgerDataWithGroups(temp1)
                setProfitAndLossStartDate(temp3)
                setProfitAndLossEndDate(temp4)
                updateFilterCheckBox();  
            }
        } catch(error) {  
            if (error?.response?.status === 403) {
                setToastErrorMessage('You are not authorized to perform this action')
                navigate('/access-denied');
                return;  
            }
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.log(error)
            setExportBtnLoading(false)
            setLoading(false)
            setSubLedgerWithGroupseLoading(false)
            !isExport &&navigate('/404')    
        } finally{
            !isExport &&updateFilterCheckBox();            
            setLoading(false)
            setExportBtnLoading(false)
            setSubLedgerWithGroupseLoading(false)

        }
    }, [searchParams, FYLoading]);

    /* The below code is a React function component that defines a `getSubLedgerAPICall` function using the
    `useCallback` hook. This function is an asynchronous function that makes an API call to retrieve
    subledger data based on the `mainGroup` parameter and various query parameters from the
    `searchParams`. */
    const getSubLedgerAPICall = useCallback(async (mainGroup, isExport) => {
        const ledgerPath = formatAndSetPath(mainGroup?.toLowerCase(), location.pathname, true)
        try {   
            isExport ? setExportBtnLoading(true) : setSubLedgerLoading(true)     
            const branch_id = await GetBranchId()
            let endpoint = `profit-and-loss/view-student-details?branch_id=${branch_id}&main_parent=${mainGroup}&ledger=${ledgerPath}${
                isExport ?`&export=true` : ''}${
                searchParams.get('ledger_id')  === null ? '' : `&ledger_id=${searchParams.get('ledger_id') }`}${
                searchParams.get('ay_id')  === null ? '' : `&academic_year_id=${searchParams.get('ay_id') }`}${
                searchParams.get('class_id')  === null  ? '' : `&class_id=${searchParams.get('class_id')}`}${
                searchParams.get('section_id')  === null  ? '' : `&section_id=${searchParams.get('section_id')}`}${`${
                searchParams?.get('start_date') === null ? `&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams?.get('start_date')}`}${
                searchParams?.get('end_date') === null ? `&end_date=${endDate.substring(0, 10)}` :`&end_date=${searchParams?.get('end_date')}`}`}`;
            const response = await dataService.GetAPI(endpoint)
            if(isExport) {
                setToastmessage(response?.data?.data?.message)
                window.open(response?.data?.data?.pre_signed_url)
            } else {
                const temp1 = response?.data?.data
                const temp4 = response?.data?.data?.end_date
                if(response?.data?.data?.data?.length === 0){
                    navigate('/financial-statements/profit-and-loss-sheet')
                    setToastErrorMessage("Something went wrong")
                } 
                setSubLedgerData(temp1)
                setProfitAndLossEndDate(temp4)
                updateFilterCheckBox();  
            }
        } catch(error) {  
            if (error?.response?.status === 403) {
                setToastErrorMessage('You are not authorized to perform this action')
                navigate('/access-denied');
                return;  
            }
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.log(error)
            setLoading(false)
            setExportBtnLoading(false)
            setSubLedgerLoading(false)
            !isExport &&navigate('/404')    
        } finally{
            !isExport &&updateFilterCheckBox();   
            setLoading(false)
            setExportBtnLoading(false)
            setSubLedgerLoading(false)

        }
    }, [searchParams, FYLoading]);

    /* The above code is a JavaScript React function that makes an API call to retrieve transaction data
    based on the main group provided. It sets up the necessary parameters for the API endpoint,
    including branch ID, main group, ledger path, and various search parameters like page number, ledger
    ID, academic year ID, class ID, section ID, student ID, start date, and end date. */
    const getTransactionTableAPICall = useCallback(async (mainGroup, isExport) => {
        const ledgerPath = formatAndSetPath(mainGroup?.toLowerCase(), location.pathname, true)
        try {   
            isExport ? setExportBtnLoading(true) : setTransactionTableLoading(true)     
            const branch_id = await GetBranchId()
            let endpoint = `profit-and-loss/view-transactions?branch_id=${branch_id}&main_parent=${mainGroup}&ledger=${ledgerPath}${
                isExport ?`&export=true` : ''}${
                searchParams?.get('page_number') === null ? `&page_number=1` : `&page_number=${searchParams?.get('page_number')}`}${
                searchParams.get('ledger_id')  === null ? '' : `&ledger_id=${searchParams.get('ledger_id') }`}${
                searchParams.get('grand_total')  === null && searchParams.get('ay_id')  === null  ? '&is_students_details=false' : `&is_students_details=true`}${
                searchParams.get('ay_id')  === null ? '' : `&academic_year_id=${searchParams.get('ay_id') }`}${
                searchParams.get('class_id')  === null  ? '' : `&class_id=${searchParams.get('class_id')}`}${
                searchParams.get('section_id')  === null  ? '' : `&section_id=${searchParams.get('section_id')}`}${
                searchParams.get('student_uuid')  === null  ? '' : `&student_uuid=${searchParams.get('student_uuid')}`}${`${
                searchParams?.get('start_date') === null ? `&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams?.get('start_date')}`}${
                searchParams?.get('end_date') === null ? `&end_date=${endDate.substring(0, 10)}` :`&end_date=${searchParams?.get('end_date')}`}`}`;
            const response = await dataService.GetAPI(endpoint)
            if(isExport) {
                setToastmessage(response?.data?.data?.message)
                window.open(response?.data?.data?.pre_signed_url)
            } else {
                const temp1 = response?.data?.data
                const temp2 = response?.data?.data?.total_count
                const temp3 = response?.data?.data?.start_date
                const temp4 = response?.data?.data?.end_date
                if(response?.data?.data?.data?.length === 0 || response?.data?.data?.total_count === 0){
                    navigate('/financial-statements/profit-and-loss-sheet')
                    setToastErrorMessage("Something went wrong")
                }
                setTransactionList(temp1)
                setTransactionCount(temp2)
                setProfitAndLossStartDate(temp3)
                setProfitAndLossEndDate(temp4)
                updateFilterCheckBox();  
            }
        } catch(error) {  
            if (error?.response?.status === 403) {
                setToastErrorMessage('You are not authorized to perform this action')
                navigate('/access-denied');
                return;  
            }
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.log(error)
            setLoading(false)
            setExportBtnLoading(false)
            setTransactionTableLoading(false)
            !isExport &&navigate('/404')    
        } finally{
            !isExport &&updateFilterCheckBox();            
            setLoading(false)
            setExportBtnLoading(false)
            setTransactionTableLoading(false)
        }
    }, [searchParams, FYLoading]);

    /* The below code is using the `useEffect` hook in a React component to call the functions
    `getFinancialYears()` and `getAcademicYears()` when the component mounts. The `useEffect` hook is
    used to perform side effects in function components, such as fetching data, subscribing to events,
    or updating the DOM. In this case, the `useEffect` hook is being used with an empty dependency array
    `[]`, which means the effect will only run once when the component mounts. */
    useEffect(()=>{
        getFinancialYears()
        getAcademicYears()
    },[])

    /* The below code is a React useEffect hook that runs when the `location.pathname` changes. It converts
    the `searchParams` into an object, checks if the current path is
    '/financial-statements/profit-and-loss-sheet', and if so, sets the `pageType` state to 'main' and updates
    the `searchParams` state with the new parameters. */
    useEffect(()=>{
        if (startDate != null && !FYLoading) {
            let params = Object.fromEntries(searchParams);
            if (location.pathname === '/financial-statements/profit-and-loss-sheet') {
                setPageType('main')
                // Remove params.type before adding search parameters
                const searchParamsCopy = new URLSearchParams(searchParams);
                searchParamsCopy.delete('type');
            }
        }
    }, [location.pathname, startDate, FYLoading])

    const calculateEndDate = (fyEndDate) => {
        const fyEndDate1 = new Date(fyEndDate);
        const currentDate = moment().endOf('day');
        return currentDate <= fyEndDate1 ? currentDate.toISOString() : fyEndDate;
    }

    useEffect(() => {
        if (reloadFY) {
            handleApplyFilter(false)
            window.location.reload();
            setReloadFY(false);
        }
    }, [reloadFY]);

    /* The below code is a React useEffect hook that is triggered whenever the `searchParams` dependency
    changes. If the `pageType` is equal to 'main', it calls the `getProfitAndLossViewCall()` function.
    This code is likely used to fetch and update the profit and loss view data based on the search
    parameters when the page type is 'main'. */
    useEffect(() => {
        if (startDate != null && !FYLoading) {
            const path = window.location.pathname;
            const onPopState = (event) => {
                // Remove the unwanted parameter
                window.history.replaceState({}, document.title, path);
            };
            ValidateParamsAndRedirect()
            if (
                path === '/financial-statements/profit-and-loss-sheet' &&
                window.location.search.includes('type=') &&
                !window.location.search.includes('type=main')
            ) {
                window.addEventListener('popstate', onPopState);
                navigate('/financial-statements/profit-and-loss-sheet')
                return () => window.removeEventListener('popstate', onPopState);
            } else {
                let mainGroup;
                let isExport = false
                const pathSegments = window.location.pathname.split('/');
                if (pathSegments.includes('income')) {
                    mainGroup = 'Income';
                } else if (pathSegments.includes('expenses')) {
                    mainGroup = 'Expenses';
                }
                setPageType(searchParams?.get('type') === null ? 'main' : searchParams?.get('type'))
                if (pageType === 'main' || location.pathname === '/financial-statements/profit-and-loss-sheet') {
                    getProfitAndLossViewCall(isExport);
                } else {
                    setLoading(false);
                }
                if (searchParams?.get('type') === 'opening-stock') getOpeningStockListAPICall(isExport)
                if (searchParams?.get('type') === 'closing-stock') getClosingStockListAPICall(isExport)
                if (searchParams?.get('type') === "group" || searchParams?.get('type') === 'mainGroup') getSubLedgerWithGroupsAPICall(mainGroup, isExport)
                if (searchParams?.get('type') === "drill_down") getSubLedgerAPICall(mainGroup, isExport)
                if (searchParams?.get('type') === 'transaction') getTransactionTableAPICall(mainGroup, isExport)
            }
        }
    }, [searchParams, navigate, startDate, FYLoading]);

    return (
        <CardHeader noPadding>
            {/* top bar */} 
            <div className="mainDataCntnrTop shadow-s13">
                <div className="flex items-center">
                    <h5 class=" pageHeader adderror">
                        Profit and Loss Sheet
                    </h5>
                </div> 
                <div className='flex items-center'>
                    {<div class="relative">
                        <button 
                            disabled={loading || openingStockLoading || closingStockTableLoading || transactionTableLoading || ledgerTableloading || subLedgerLoading || subLedgerWithGroupsLoading}
                            onClick={() => {
                                handleOpenFilter()
                            }} type="button" id="filter_btn" >
                            <img loading="lazy" src="/images/Filter_Icon.svg" alt="img" class="w-[15px] h-[15px]"/>
                            <span class="text-f2 font-normal text-[#106EB4] pl-2.5">Filter</span>
                            {filterCount !== 0 && <p class="p-2 text-[14px] leading-[7px] font-semibold text-[#FFFFFF] ml-2 bg-[#106EB4] rounded-[50%]">{filterCount}</p>}
                        </button>
                        {isFilterOpen && 
                        <Filter 
                            filterCount={filterCount}
                            selectedDateRange={selectedDateRange}
                            setSelectedDateRange={setSelectedDateRange}
                            selectedName={selectedName}
                            setSelectedName={setSelectedName}
                            searchParams={searchParams}
                            currentFinacialYear={currentFinacialYear}
                            handleSelectObject={handleSelectObject}
                            FilterCheckbox={FilterCheckbox}
                            setFilterCheckBox={setFilterCheckBox} 
                            FilterData={FilterData}
                            handleApplyFilter={handleApplyFilter}
                            setIsFilterOpen={setIsFilterOpen}
                            selectedFilter={selectedFilter}
                            setSelectedFilter={setSelectedFilter}  
                            radioButton={true}   
                            finacialYear={finacialYear}  
                            academicYears={academicYears}
                            setSearchParams={setSearchParams} 
                            setStartDate={setStartDate} 
                            setEndDate={setEndDate}   
                            calculateEndDate={calculateEndDate}
                        />}
                    </div>}
                    {<button onClick={()=>{exportBtnhandler()}} id='export'
                        className={`prmy-btn export_btn`}>
                        {exportBtnLoading ? <Loader /> : 'Export'}
                    </button> }
                </div>
                {toastErrorMessage !== "" && (
                    <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage}
                    />
                )}
            </div>
            <>
                {loading ? <div>
                    <CustomOverLay Active text="Loading..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay max-h-[calc(100vh-70px)]`}/> 
                </div> : <div className="mainDataCntnrListDiv scrollBlue_thick">
                    {/* the end date is shown on the profit and loss sheet as on date */}
                    <div className="fxd_heading">
                        <p>P & L  from <span id='profit_and_loss_start_date' className="font-semibold ">{formatMMDDate(profitAndLossStartDate)}</span> to <span id='profit_and_loss_end_date' className="font-semibold ">{formatMMDDate(profitAndLossEndDate)}</span></p>
                    </div>
                    {/* This is the Nav Bar (Bread Crums) which appers when you drill down into the profit and loss sheet */}
                    {pageType !== 'main' && (
                        <NavBar 
                            profitAndLoss={profitAndLoss} 
                            searchParams={searchParams} 
                            pageType={pageType}
                            setPageType={setPageType}
                            isLoading={loading || openingStockLoading || closingStockTableLoading || transactionTableLoading || ledgerTableloading || subLedgerLoading || subLedgerWithGroupsLoading}
                        />
                    )}
                    {/* this codition when true will show the landing page of profit and loss sheet */}
                    {pageType==='main' &&<div style={{'padding-top':'32px'}}>
                        {ledgerTableloading ? 
                            <div className="flex justify-between border border-[#C2DCEF] overflow-auto scroll-bar mb-10 min-h-[512px]">
                                <div className="w-1/2 mr-[10px] min-w-[400px]">
                                    <ShimmerLedgerTable/>
                                </div>
                                <div className="w-1/2 ml-4 min-w-[400px]">
                                    <ShimmerLedgerTable/>
                                </div>
                            </div> :
                            <div>
                                <div className="flex justify-between border border-[#C2DCEF] overflow-auto scroll-bar mb-10 min-h-[512px]">
                                    <div className="w-1/2 mr-[10px] min-w-[400px]">
                                        <LedgerTable 
                                            mainHeading={'Expenses'} 
                                            ledgerData={profitAndLoss?.Expenses?.items}
                                            totalBalance={profitAndLoss?.Expenses?.balance}
                                            totalBalanceType={profitAndLoss?.Expenses?.type}
                                            mainPath={'p & l/expenses'}
                                            searchParams={searchParams}
                                            setSearchParams={setSearchParams}
                                            setPageType={setPageType}
                                            netProfit={netProfit}
                                            setStockTableLoading={setOpeningStockTableLoading}
                                        />
                                    </div>
                                    <div className="w-1/2 ml-4 min-w-[400px]">
                                        <LedgerTable 
                                            mainHeading={'Income'} 
                                            ledgerData={profitAndLoss?.Income?.items}
                                            totalBalance={profitAndLoss?.Income?.balance}
                                            totalBalanceType={profitAndLoss?.Income?.type}
                                            mainPath={'p & l/income'}
                                            searchParams={searchParams}
                                            setSearchParams={setSearchParams}
                                            setPageType={setPageType}
                                            setStockTableLoading={setClsoingStockTableLoading}
                                        />
                                    </div>
                                </div>
                            </div>}
                    </div>}
                    {/* this condtion when true will show the any sub ledger page after drilling down from the main page */}
                    {pageType === 'drill_down' && (
                        <div>
                            {subLedgerLoading ? (
                                <div className="">
                                    <ItemShimmer />
                                </div>
                            ) : (
                                <div>
                                    <SubLedgerTable
                                        tableData={subLedgerData}
                                        searchParams={searchParams}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                    {/* this condtion when true will show the any sub group page after drilling down from the main page */}
                    {(pageType === 'group' || pageType === 'mainGroup') && (
                        <div>
                            {subLedgerWithGroupsLoading ? (
                                <div className="">
                                    <ItemShimmer />
                                </div>
                            ) : (
                                <div>
                                    <SubLedgerTable
                                        tableData={subLedgerDataWithGroups}
                                        searchParams={searchParams}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                    {/* this condition when true will show the main opening stock table inside Expenses > OpeningStock  */}
                    {pageType === 'opening-stock' && <div>
                        {openingStockLoading ? <div className="">
                            <ItemShimmer/>
                        </div> : <div>
                            <OpeningStockTable 
                                OpeningStockList={openingStockList} 
                                searchParams={searchParams}
                                setSearchParams={setSearchParams}
                                OpeningStockCount={openingStockCount}
                                setPageLoading={setOpeningStockTableLoading}
                            />
                        </div>}
                    </div>}
                    {/* this condition when true will show the closing stock table inside Income > Closing Stock  */}
                    {pageType === 'closing-stock' && <div>
                        {closingStockTableLoading ? <div className="">
                            <ItemShimmer/>
                        </div> : <div>
                            <ClsoingStockTable
                                ClosingStockList={closingStockList}
                                searchParams={searchParams}
                                setSearchParams={setSearchParams}
                                ClosingStockCount={closingStockCount}
                                navigate={navigate}
                                setPageType={setPageType}
                                setPageLoading={setClsoingStockTableLoading}
                            />
                        </div>}
                    </div>}
                    {/* this condition when true will show the transaction table. The last page of any drill down from the main page */}
                    {pageType === 'transaction' && (
                        <div>
                            {transactionTableLoading ? (
                                <div className="">
                                    <ItemShimmer />
                                </div>
                            ) : (
                                <div>
                                    <TransactionTable
                                        TransactionList={transactionList}
                                        searchParams={searchParams}
                                        setSearchParams={setSearchParams}
                                        TransactionCount={transactionCount}
                                        setPageLoading={setTransactionTableLoading}
                                        formatMMDDate={formatMMDDate}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </div>}
            </>
        </CardHeader>
    )
}
export default ProfitAndLoss;